var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSlackNewLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#36C5F0",
    d: "M8.615 0c-1.299.001-2.35 1.055-2.35 2.354 0 1.299 1.052 2.353 2.351 2.354h2.35V2.355C10.967 1.056 9.915.002 8.615 0c.001 0 .001 0 0 0m0 6.278H2.35C1.051 6.28 0 7.333 0 8.632c-.002 1.3 1.05 2.353 2.35 2.355h6.265c1.299 0 2.351-1.055 2.35-2.354.001-1.3-1.051-2.354-2.35-2.355z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2EB67D",
    d: "M23.497 8.632c0-1.299-1.051-2.353-2.35-2.354-1.299.001-2.351 1.055-2.35 2.354v2.355h2.35c1.299 0 2.35-1.055 2.35-2.355zm-6.266 0V2.354c.001-1.298-1.05-2.352-2.35-2.354-1.298.001-2.35 1.055-2.35 2.354v6.278c-.001 1.3 1.051 2.353 2.35 2.355 1.299 0 2.351-1.055 2.35-2.355z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ECB22E",
    d: "M14.881 23.544c1.299-.001 2.351-1.055 2.35-2.354.001-1.299-1.051-2.353-2.35-2.354h-2.35v2.354c-.001 1.298 1.051 2.352 2.35 2.354zm0-6.28h6.266c1.299 0 2.35-1.054 2.35-2.353.002-1.3-1.05-2.353-2.35-2.355h-6.265c-1.299 0-2.351 1.055-2.35 2.354-.001 1.3 1.05 2.354 2.349 2.355z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E01E5A",
    d: "M0 14.91c-.001 1.3 1.051 2.354 2.35 2.355 1.299-.001 2.351-1.055 2.35-2.354v-2.354H2.35C1.051 12.557 0 13.612 0 14.91zm6.266 0v6.28c-.002 1.298 1.05 2.352 2.349 2.354 1.299-.001 2.351-1.055 2.35-2.354v-6.277c.002-1.3-1.05-2.353-2.349-2.355-1.3 0-2.351 1.054-2.35 2.353"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlackNewLogo);
export default __webpack_public_path__ + "static/media/slack-new-logo.ce5e1556.svg";
export { ForwardRef as ReactComponent };